import { FILTERS_NAME } from '@va/constants';
import { ConversionEventKind, ConversionEventTypes } from '@va/dashboard/shared/conversions';
import { useTranslate } from '@va/localization';
import { buildNestedFiltersPage, FilterLogicalOperators } from '@va/types/filters';
import { isWixApp } from '@va/util/helpers';
import { useConversionEventKindFilter } from './useConversionEventKindFilter';

export const useConversionEventsFilter = () => {
  const translate = useTranslate();

  const websitePageFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.WebsitePageUrl]);
  const urlPatternFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.CustomUrlPattern]);
  const outgoingTrafficFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.OutgoingTraffic]);
  const autoEventFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.AutoEvents]);
  // const funnelFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.Funnel]);
  const customEventFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.CustomEvents]);
  const ecomEventFilter = useConversionEventKindFilter(ConversionEventKind[ConversionEventTypes.ECommerceEvents]);

  const filters = [
    websitePageFilter,
    urlPatternFilter,
    outgoingTrafficFilter,
    autoEventFilter,
    // funnelFilter
  ];

  if (!isWixApp()) {
    filters.push(customEventFilter, ecomEventFilter);
  }

  return buildNestedFiltersPage({
    id: 'conversion-events',
    name: FILTERS_NAME.CONVERSION_EVENTS,
    label: translate('filters.labels.conversionEvents'),
    filters,
    childrenLogicalOperator: FilterLogicalOperators.or,
  });
};
